import React, { useState } from 'react';

const KnowBeforeYouGoSection = () => {
  const [isExpanded, setIsExpanded] = useState(true);

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="mb-12 bg-gray-900/50 rounded-lg border border-purple-500/30 p-6">
      <div 
        className="flex items-center justify-between cursor-pointer"
        onClick={toggleExpanded}
      >
        <h3 className="text-3xl font-bold text-white">Know Before You Go</h3>
        <button className="text-purple-400 hover:text-purple-300 transition-colors">
          <span className="text-sm font-semibold">
            {isExpanded ? 'Hide Details' : 'Show Details'}
          </span>
        </button>
      </div>

      {isExpanded && (
        <div className="mt-6 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {/* Darkness */}
          <div className="flex flex-col items-center p-4 bg-black/30 rounded-lg">
            <div className="w-12 h-12 mb-3 bg-purple-600 rounded-full flex items-center justify-center">
              <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 20 20">
                <path d="M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z" />
              </svg>
            </div>
            <span className="text-white text-sm font-semibold text-center">Darkness</span>
          </div>

          {/* Not Recommended For Children Under 12 */}
          <div className="flex flex-col items-center p-4 bg-black/30 rounded-lg">
            <div className="w-12 h-12 mb-3 bg-purple-600 rounded-full flex items-center justify-center">
              <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 20 20">
                <path d="M10 2L3 7v11c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V7l-7-5zM12 17H8v-6h4v6z"/>
                <path d="M9 9h2v2H9z"/>
              </svg>
            </div>
            <span className="text-white text-sm font-semibold text-center">Not Recommended For<br/>Children Under 12</span>
          </div>

          {/* Show Duration */}
          <div className="flex flex-col items-center p-4 bg-black/30 rounded-lg">
            <div className="w-12 h-12 mb-3 bg-purple-600 rounded-full flex items-center justify-center">
              <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
              </svg>
            </div>
            <span className="text-white text-sm font-semibold text-center">90 minute show with a<br/>15 minute intermission</span>
          </div>

          {/* Photography Policy */}
          <div className="flex flex-col items-center p-4 bg-black/30 rounded-lg">
            <div className="w-12 h-12 mb-3 bg-purple-600 rounded-full flex items-center justify-center">
              <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M4 5a2 2 0 00-2 2v8a2 2 0 002 2h12a2 2 0 002-2V7a2 2 0 00-2-2h-1.586a1 1 0 01-.707-.293l-1.121-1.121A2 2 0 0011.172 3H8.828a2 2 0 00-1.414.586L6.293 4.707A1 1 0 015.586 5H4zm6 9a3 3 0 100-6 3 3 0 000 6z" clipRule="evenodd" />
              </svg>
            </div>
            <span className="text-white text-sm font-semibold text-center">No Photography<br/>During Show</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default KnowBeforeYouGoSection;